import { render } from "./IncomeHeadList.vue?vue&type=template&id=4b84e3bd"
import script from "./IncomeHeadList.vue?vue&type=script&lang=js"
export * from "./IncomeHeadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__